import React, { lazy, Suspense }  from 'react';
import DashBoardTab from '../DashBoard/DashBoardTab';
import Loader from '../Loader/Loader';
import AuthSettings from '../Auth/AuthSettings';
import WhatsAppIcon from '../Social/WhatsAppIcon';
import OtherServiceChannels from '../Modal/OtherService';
import AdsModal from '../Modal/AdsModal';

const SearchBarBS = lazy(() => import('../SearchBar/SearchBarBS'));
const SmallScreenSearch = lazy(() => import('../SearchBar/SmallScreenSearch'));
const SearchBarSS = lazy(() => import('../SearchBar/SearchBarSS'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
// const OtherServiceChannels = lazy(() => import('../Modal/OtherService'));
const Waiting = lazy(() => import('../Loader/Waiting'));
const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../DropDown/ContactUs'));
const ReviewDisplay = lazy(() => import('./ReviewDisplay'));
const Footer = lazy(() => import('../Footer/Footer'));

const CustomerReview = () => {
  return (
    <div className='dashboard'>
      <Suspense fallback={<Loader/>}>
        <ModalMenu />
        <OtherServiceChannels />
        <SmallScreenSearch />
        <SearchBarBS />
        <SearchBarSS />
        <Waiting />
      </Suspense>
      
      <DashBoardTab />
      <AuthSettings />
      <WhatsAppIcon />
      <AdsModal />

      <Suspense fallback={<Loader/>}>
        <ShopAll />
        <OnDemand />
        <Recommended />
        <OurLocations />
        <ContactUs />
      </Suspense>

      <Suspense fallback={<Loader/>}>
        <ReviewDisplay />
      </Suspense>


      <Suspense fallback={<Loader/>}>
        <Footer />
      </Suspense>
    </div>
  )
};


export default CustomerReview;